module.exports = __webpack_public_path__ + "static/media/user.5adc2168.svg";